@if (!isEmpty(get(featureSolutionsRow, 'feature_solutions', ''))) {
  @for (row of get(featureSolutionsRow, 'feature_solutions.feature_solutions', []); track row) {
    <div>
      <section id="rows" class="d-flex flex-column container-gridless feature-solutions">
        <div class="d-flex flex-row justify-content-center">
          <h2 class="text-center col-md-7 solution-title">
            {{ get(featureSolutionsRow.feature_solutions, 'feature_solutions_title', '') }}
          </h2>
        </div>
        <div id="feature-cards-container">
          @for (solution of get(row, 'feature_solutions', []); track solution) {
            <div class="feature-card">
              <div class="d-flex flex-column align-items-center w-100">
                <div id="cms-partial-category-feature-solutions-img" class="text-center">
                  <a [routerLink]="get(solution, 'spec_link.routerLink', '')"
                    >@if (get(solution, 'image.href', '')) {
                    <img [src]="getWebpImg(solution.image.href)" [alt]="solution.image.title"
                      />
                  }</a>
                </div>
                <div class="mpn-title-spacing">
                  @if (get(solution, 'displayMpn', '')) {
                    <h5 class="text-center mpn">{{ get(solution, 'displayMpn', '') }}</h5>
                  }
                  <a [routerLink]="get(solution, 'spec_link.routerLink', '')" class="solution-link"
                    ><h4 class="text-center mt-0 mb-0 title">
                    @if (get(solution, 'title', ''); as splitTitle) {
                      <span>{{ splitWord(splitTitle).firstPart }}</span>
                      <span class="last-word">
                        <span [class.last-word-text]="get(solution, 'title', '')"
                          >{{ ' ' }}{{ splitWord(splitTitle).lastPart }}</span
                          >
                          <i-feather name="chevron-right"></i-feather>
                        </span>
                        }</h4
                      ></a>
                    </div>
                    <div class="gap-container">
                      @if (solution?.product?.price) {
                        <div class="starting">
                          <p class="starting-copy">Starting at</p>
                          <span class="starting-price">{{ solution?.product?.price }}</span>
                        </div>
                      }
                      @if (solution?.customNotes?.length) {
                        <div class="custom-note-container">
                          @for (note of solution.customNotes; track note) {
                            <p class="custom-note">{{ note }}</p>
                          }
                        </div>
                      } @else {
                        @if (solution?.solution_specs || solution?.product?.price) {
                          <hr class="m-0 p-0" />
                        }
                      }
                      @if (solution?.solution_specs) {
                        <div class="text-center spec" [innerHTML]="solution?.solution_specs"></div>
                      }
                      @if (!solution?.solution_specs) {
                        <div class="text-center spec" [innerHTML]="solution?.product?.highlights"></div>
                      }
                      <div class="d-flex flex-column justify-content-center button-container w-100">
                        @if (
                          get(solution, 'configuratorMpn', '') &&
                          get(solution, 'button_text_select', '') &&
                          !solution.isBlackListed &&
                          solution.exxcomIsActive
                        ) {
                          <a
                            class="button-primary button-base"
                            [href]="encodeConfiguratorUrl('https://configurator.sabrepc.com/configure/', get(solution, 'configuratorMpn', ''))"
                            >
                            <span class="d-flex justify-content-center align-items-center">
                              <i-feather name="tool" class="tool-icon mr-1"></i-feather>
                              Configure</span
                              >
                            </a>
                          }
                          @if (get(solution, 'inquiry_form.id', '') && get(solution, 'no_form', '') !== true) {
                            <button
                              class="button-secondary button-base"
                                    (click)="
                                        bootstrapMarketoService.openBootstrapMarketoDialog(get(solution, 'inquiry_form.id', ''), 'edit', {
                                            title: get(solution, 'title', ''),
                                            url: solutionUrl,
                                            productInfo: {
                                                mpn: get(solution, 'displayMpn', ''),
                                                solutionTitle: get(solution, 'title', '')
                                            }
                                        })
                                    "
                            >
                            <span class="d-flex justify-content-center align-items-center">
                              <i-feather name="message-circle" class="button-icon mr-1"></i-feather>
                              {{ get(solution, 'button_text_select', '') }}</span
                              >
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </section>
          </div>
        }
      }
      @if (get(featureSolutionsRow, 'feature_solutions.split_line', '')) {
        <hr class="m-0" />
      }
